// Deru jet disintesis Web Audio (tanpa file): derau putih → bandpass menyapu (efek doppler) → envelope → panner kiri→kanan mengikuti pesawat.
let ctx = null;

function konteks() {
  if (!ctx) { const AC = window.AudioContext || window.webkitAudioContext; if (!AC) return null; ctx = new AC(); }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

// Mainkan deru selama `durasi` ms (sesuai pesawat melintas kiri→kanan). Aman dipanggil hanya setelah gestur pengguna.
export function deruPesawat(durasi = 18000, volume = 0.5) {
  const ac = konteks();
  if (!ac) return () => {};
  const d = durasi / 1000, t0 = ac.currentTime;
  const buf = ac.createBuffer(1, ac.sampleRate * 2, ac.sampleRate), data = buf.getChannelData(0);
  for (let i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;
  const src = ac.createBufferSource(); src.buffer = buf; src.loop = true;
  const bp = ac.createBiquadFilter(); bp.type = "bandpass"; bp.Q.value = 0.8;
  bp.frequency.setValueAtTime(220, t0); bp.frequency.linearRampToValueAtTime(900, t0 + d * 0.5); bp.frequency.linearRampToValueAtTime(260, t0 + d);   // doppler: naik lalu turun
  const lp = ac.createBiquadFilter(); lp.type = "lowpass"; lp.frequency.value = 2600;
  const gain = ac.createGain();
  gain.gain.setValueAtTime(0, t0); gain.gain.linearRampToValueAtTime(volume, t0 + d * 0.45); gain.gain.setValueAtTime(volume, t0 + d * 0.55); gain.gain.linearRampToValueAtTime(0, t0 + d);
  let keluar = gain;
  if (ac.createStereoPanner) { const pan = ac.createStereoPanner(); pan.pan.setValueAtTime(-1, t0); pan.pan.linearRampToValueAtTime(1, t0 + d); gain.connect(pan); keluar = pan; }
  src.connect(bp); bp.connect(lp); lp.connect(gain); keluar.connect(ac.destination);
  src.start(t0); src.stop(t0 + d + 0.1);
  return () => { try { gain.gain.cancelScheduledValues(ac.currentTime); gain.gain.linearRampToValueAtTime(0, ac.currentTime + 0.3); src.stop(ac.currentTime + 0.35); } catch { /* sudah berhenti */ } };
}

// Ramp volume HTMLAudio secara halus (volume HTMLAudio tidak bisa diotomasi)
export function rampVolume(audio, target, ms = 600) {
  const awal = audio.volume, t0 = performance.now();
  if (audio._ramp) cancelAnimationFrame(audio._ramp);
  const langkah = () => { const k = Math.min(1, (performance.now() - t0) / ms); audio.volume = awal + (target - awal) * k; if (k < 1) audio._ramp = requestAnimationFrame(langkah); };
  audio._ramp = requestAnimationFrame(langkah);
}
